import { NextGenSettingsOrg } from '@wetags/next-gen-settings';

export const useWeaveAssistantSettingsFeatureFlag = () => {
  const [featureFlagEnabled] = NextGenSettingsOrg.useWetag('next-gen-settings');
  return featureFlagEnabled;
};
